module.exports = __webpack_public_path__ + "img/wide.20386474.jpg";